module.exports = __webpack_public_path__ + "img/icon_radius3.442c6644.png";